import React from "react";
import {
  ResponsiveContainer,
  BarChart as ReBarChart,
  Bar,
  Tooltip,
  CartesianGrid,
  XAxis,
  YAxis,
} from "recharts";

interface BarChartProps {
  data: any[];
  dataKey: string;
  xKey: string;
  containerClassName?: string;
  barColor?: string;
  barRadius?: [number, number, number, number];
  hideXAxis?: boolean;
  hideYAxis?: boolean;
  xAxisProps?: Record<string, any>;
  yAxisProps?: Record<string, any>;
  tooltipFormatter?: (value?: number) => string | [string, string];
  tooltipLabelFormatter?: (label?: string) => string;
}

const BarChart: React.FC<BarChartProps> = ({
  data,
  dataKey,
  xKey,
  containerClassName = "mt-4 h-44 w-full",
  barColor = "#A5B4FC",
  barRadius = [8, 8, 8, 8],
  hideXAxis = false,
  hideYAxis = false,
  xAxisProps,
  yAxisProps,
  tooltipFormatter,
  tooltipLabelFormatter,
}) => {
  return (
    <div className={containerClassName}>
      <ResponsiveContainer width="100%" height="100%">
        <ReBarChart data={data} margin={{ top: 10, right: 10, left: 0, bottom: 0 }}>
          <CartesianGrid stroke="#E5E7EB" vertical={false} />
          <XAxis dataKey={xKey} hide={hideXAxis} {...xAxisProps} />
          <YAxis hide={hideYAxis} {...yAxisProps} />
          <Tooltip
            contentStyle={{
              borderRadius: "8px",
              borderColor: "#E5E7EB",
              fontSize: "12px",
            }}
            labelStyle={{ fontWeight: 600 }}
            formatter={tooltipFormatter}
            labelFormatter={tooltipLabelFormatter}
          />
          <Bar dataKey={dataKey} fill={barColor} radius={barRadius} />
        </ReBarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default BarChart;
